import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import UnauthorizedPopup from './UnauthorizedPopup';
import { useNavigate } from 'react-router-dom';

interface RoleGuardProps {
    children: React.ReactNode;
    allowedRoles: string[];
}

const RoleGuard: React.FC<RoleGuardProps> = ({ children, allowedRoles }) => {
    const { user } = useAuth();
    const [showPopup, setShowPopup] = useState(false);
    const navigate = useNavigate();

    // Mapping role aliases if needed (e.g. backend uses 'osgb_admin' but we might just pass 'admin' somewhere)
    // For now assuming direct mapping. 'osgb_admin' is the key one.
    // The user model has: 'admin', 'user', 'expert', 'doctor', 'client', 'osgb_admin', 'accounting', 'hr', 'viewer'

    const hasPermission = () => {
        if (!user) return false;
        // 'osgb_admin' generally has access to everything
        if (user.role === 'osgb_admin' || user.role === 'admin') return true;
        return allowedRoles.includes(user.role);
    };

    useEffect(() => {
        if (!hasPermission()) {
            setShowPopup(true);
        }
    }, [user, allowedRoles]);

    const handleClose = () => {
        setShowPopup(false);
        // Redirect to dashboard or home, or stay?
        // User requested "bu sayfayı ziyaret etme yetkiniz bulunmamaktadır"
        // Usually implies we block the content.
        // If we just close popup and show content, that defeats the purpose.
        // We should probably redirect to a safe page like /dashboard.
        // But if we are ON the dashboard and don't have permission? (Unlikely)
        // Let's redirect to root relative to their context, or just go 'back' if possible, or '/'
        navigate('/');
    };

    if (!hasPermission()) {
        // We show the popup. Behind it, we show nothing (null) or maybe a blurred div?
        // Using null for security so data isn't even rendered in DOM.
        return (
            <>
                {showPopup && <UnauthorizedPopup onClose={handleClose} />}
                {/* We return null for the content so it is NOT rendered */}
            </>
        );
    }

    return <>{children}</>;
};

export default RoleGuard;
